// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import Zone from "@insite/client-framework/Components/Zone";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { StyledHr } from "@steiner/XDL/Utilities";
import React, { FC } from "react";
import { connect, shallowEqual } from "react-redux";

interface OwnProps {
    id: string;
    showBackLink?: boolean;
    overrideTitle?: string;
}

interface CheckoutHeadingStyles {
    container?: InjectableCss;
    title?: TypographyPresentationProps;
    innerContainer?: InjectableCss;
    styledHr?: InjectableCss;
}

export const checkoutHeadingStyles: CheckoutHeadingStyles = {};

const styles = checkoutHeadingStyles;
const CheckoutHeading: FC<OwnProps> = ({ id, overrideTitle, showBackLink = true }) => {
    const { cartUrl } = useAppSelector(
        state => ({
            cartUrl: getPageLinkByPageType(state, "CartPage")?.url,
        }),
        shallowEqual,
    );

    return (
        <StyledWrapper {...styles.container}>
            {createWidgetElement("Basic/PageTitle", {
                fields: {
                    overrideTitle: overrideTitle || translate("Checkout"),
                    showGoBack: showBackLink,
                    goBackTitle: translate("Return to Cart"),
                    goBackLink: cartUrl,
                },
            })}
            <StyledWrapper {...styles.innerContainer}>
                {createWidgetElement("CheckoutStepper/CheckoutStepper", { fields: {} })}
                <Zone zoneName="Content_CheckoutHeading" contentId={id} />
                <StyledHr {...styles.styledHr} />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default CheckoutHeading;
